import { render, staticRenderFns } from "./flatpayReports.vue?vue&type=template&id=1b6eb85c&"
import script from "./flatpayReports.vue?vue&type=script&lang=js&"
export * from "./flatpayReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports